var _rect, _rect2, _path, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    opacity: 0.3,
    width: 2.5,
    height: 10.833,
    rx: 1.25,
    transform: "translate(10 3.333)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    opacity: 0.3,
    width: 2.5,
    height: 6.667,
    rx: 1.25,
    transform: "translate(5.833 7.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.667,16.333h12.5a.833.833,0,0,1,0,1.667H3.833A.833.833,0,0,1,3,17.167V3.833a.833.833,0,1,1,1.667,0Z",
    transform: "translate(-0.5 -0.5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    opacity: 0.3,
    width: 2.5,
    height: 5,
    rx: 1.25,
    transform: "translate(14.167 9.167)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.3b68d2103982eda646bd8ce963b5d987.svg";
export { ForwardRef as ReactComponent };